/**
 * @generated SignedSource<<030c4db6a62193d5f6bce66bee07c943>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts$data = {
  readonly agentWorkspace_siteWfoStatus?: {
    readonly hasProjectEnabledWfo: boolean;
  } | null;
  readonly " $fragmentType": "ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts";
};
export type ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts$key = {
  readonly " $data"?: ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skipSiteWfoStatus"
    }
  ],
  "kind": "Fragment",
  "name": "ServiceManagementSection_queryNavigationAppsSidebarNav4SidebarsSettingsGlobalProducts",
  "selections": [
    {
      "condition": "skipSiteWfoStatus",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "AgentWorkspaceSiteWfoStatus",
          "kind": "LinkedField",
          "name": "agentWorkspace_siteWfoStatus",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasProjectEnabledWfo"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "f84375c33db785086e85d64d8da155d1";

export default node;
